// src/components/strumenti/Rifasamento.js
// Qc = P × (tan(arccos(cosφ1)) − tan(arccos(cosφ2)))
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };

export default function Rifasamento() {
  const [potenza, setPotenza] = useState("");
  const [cosphiAttuale, setCosphiAttuale] = useState("0.7");
  const [cosphiDesiderato, setCosphiDesiderato] = useState("0.9");

  const P = leggiNumero(potenza)||0;
  const cf1 = leggiNumero(cosphiAttuale)||0;
  const cf2 = leggiNumero(cosphiDesiderato)||0;

  const puoCalcolare = P>0 && cf1>0 && cf1<=1 && cf2>0 && cf2<=1;
  const phi1 = puoCalcolare ? Math.acos(cf1) : null;
  const phi2 = puoCalcolare ? Math.acos(cf2) : null;
  const qc = puoCalcolare ? P*(Math.tan(phi1)-Math.tan(phi2)) : null;
  const migliorativoNonSensato = puoCalcolare && cf2<=cf1;

  return (
    <div>
      <div style={{ marginBottom:12 }}>
        <label style={lbl}>Potenza attiva impianto P (kW)</label>
        <input value={potenza} onChange={e=>setPotenza(e.target.value)} style={inp} placeholder="Es. 100"/>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>cos φ attuale</label>
          <input value={cosphiAttuale} onChange={e=>setCosphiAttuale(e.target.value)} style={inp} placeholder="Es. 0.7"/>
        </div>
        <div>
          <label style={lbl}>cos φ desiderato</label>
          <input value={cosphiDesiderato} onChange={e=>setCosphiDesiderato(e.target.value)} style={inp} placeholder="Es. 0.9"/>
        </div>
      </div>

      {(cf1 > 1 || cf2 > 1) && <div role="alert" style={{ background:"#fef2f2", border:"1px solid #fecaca", borderRadius:8, padding:"7px 10px", marginBottom:10, fontSize:11, color:"#991b1b" }}>Il cos φ va scritto tra 0 e 1: controlla i valori.</div>}
      <div style={{ background:"#faf5ff", border:"1px solid #e9d5ff", borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Potenza reattiva di rifasamento necessaria</div>
        <div style={{ fontSize:26, fontWeight:800, color:"#7c3aed" }}>
          {qc!==null && !migliorativoNonSensato ? qc.toLocaleString("it-IT",{maximumFractionDigits:2}) : "—"}
          <span style={{ fontSize:14, marginLeft:6, color:"#9ca3af" }}>kVAR</span>
        </div>
        {migliorativoNonSensato && (
          <div style={{ fontSize:11, color:"#d97706", marginTop:6 }}>Il cos φ desiderato deve essere maggiore di quello attuale</div>
        )}
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Stima della batteria di condensatori necessaria — la taglia commerciale reale va scelta sullo step disponibile del produttore, arrotondando per eccesso.
      </div>

      <button onClick={()=>{setPotenza("");setCosphiAttuale("0.7");setCosphiDesiderato("0.9");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
